import React from 'react';
import Form from '../../../../components/forms/utils/Form';
import SingleLineField from '../../../../components/forms/SingleLineField';
import {useOutletContext} from 'react-router-dom';
import {useMutation} from '@apollo/client';
import {UPDATE_WEBSITE} from '../../../../utils/api/website';

interface RateCardProps {
  id: string;
}

const RateCard: React.FC<RateCardProps> = ({ id }) => {
  const { website } = useOutletContext<any>();
  const [updateWebsite] = useMutation(UPDATE_WEBSITE)

  const handleSubmit = async (values: any, changedValues: any) => {
    const {__typename, ...rateCard} = changedValues.rateCard

    updateWebsite({
      variables: { id: website._id, record: {rateCard} }
    })
  }
  return (
    <Form
      defaultValues={website}
      className="mt-8 flex-1 relative overflow-y-auto focus:outline-none bg-white rounded-md py-6 px-6"
      onSubmit={handleSubmit}
      submitButtonText="Save"
    >
      
      <SingleLineField
          top
          label="Read"
          htmlfor="rateCard.read"
          type="number"
          required
        />

       {/* <SingleLineField
          label="Click"
          htmlfor="rateCard.click"
          type="number"
          required
        />

        <SingleLineField
          label="Lead"
          htmlfor="rateCard.lead"
          type="number"
          required
        /> */}

    </Form>
  );
};

export default RateCard;


